module.exports = __webpack_public_path__ + "media/favicon/apple-touch-icon-f5629046.png";